<template>
  <div class="hr-area" v-loading="isLoading">
    <header-top></header-top>
    <div class="header-title">地区配置</div>
    <div class="area-container">
      <div class="container-tip">
        <svg-icon icon-class="icon-tips" class="icon-tips" />
        <ul>
          <svg-icon icon-class="tips-bg" class="icon-tips-bg" v-if="showTips" />
          <li class="tips-tit">
            小贴士
            <i
              class="el-icon-caret-top tips-btn"
              v-if="showTips"
              @click="showTip"
            ></i>
            <i
              class="el-icon-caret-bottom tips-btn"
              v-else
              @click="showTip"
            ></i>
          </li>
          <li v-if="showTips">
            <span></span>
            <div>创建地址时，请选择地图地址获取经纬度</div>
          </li>
        </ul>
      </div>
      <div class="container-main">
        <div class="main-left">
          <div class="left-operation">
            <div class="operation-btn">
              <el-tooltip
                placement="top"
                popper-class="custom-tooltip"
                effect="light"
              >
                <div slot="content">添加</div>
                <div @click="addArea">
                  <svg-icon icon-class="add-ico" class="btn-add" />
                </div>
              </el-tooltip>
              <el-tooltip
                placement="top"
                popper-class="custom-tooltip"
                effect="light"
              >
                <div slot="content">删除</div>
                <div @click="delPost">
                  <svg-icon icon-class="del-ico" class="btn-del" />
                </div>
              </el-tooltip>
            </div>
            <el-input
              class="area-search"
              placeholder="请输入标签名称"
              suffix-icon="el-icon-search"
              v-model="areaSearch"
              v-if="areaAll.length"
              clearable
            ></el-input>
          </div>
          <div class="area-items" v-show="areaAll.length">
            <el-tree
              class="custom-tree"
              lazy
              :data="areas"
              :props="{ children: 'children', isLeaf: 'isLeaf' }"
              :load="loadTreeNodes"
              @node-click="nodeClick"
              node-key="id"
            >
              <span class="custom-tree-node" slot-scope="{ data }">
                <span>{{ data.data.name }}</span>
                <el-tooltip
                  placement="top"
                  popper-class="custom-tooltip"
                  effect="light"
                >
                  <div slot="content">添加下级</div>
                  <span @click.stop="addArea(data)">
                    <svg-icon icon-class="add-ico" class="btn-append" />
                  </span>
                </el-tooltip>
              </span>
            </el-tree>
          </div>
        </div>

        <div class="main-right" v-if="operation == 'create' || areas.length">
          <el-form
            label-position="left"
            v-if="isEdit"
            label-width="4rem"
            ref="areaForm"
            :rules="areaRules"
            :model="areaForm"
          >
            <div class="edit-view">
              <div class="view-title" v-if="operation == 'create'">
                添加新地区
              </div>
              <div class="view-title" v-else>编辑地区</div>
              <div class="view-box">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="名称" prop="name">
                      <el-input
                        v-model="areaForm.name"
                        placeholder="请输入名称"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="是否启用">
                      <el-radio-group v-model="areaForm.status">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="8">
                    <el-form-item label="邮编">
                      <el-input
                        v-model="areaForm.postcode"
                        placeholder="请输入邮编"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="别名">
                      <el-input
                        v-model="areaForm.alias"
                        placeholder="请输入别名"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="类型">
                      <el-select
                        v-model="areaForm.type"
                        placeholder="请选择类型"
                        clearable
                      >
                        <el-option
                          v-for="item in areaType"
                          :key="item.option"
                          :label="item.option"
                          :value="item.option"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="备注" class="auto-height">
                      <el-input
                        v-model="areaForm.more"
                        type="textarea"
                        placeholder="请输入备注"
                        maxlength="200"
                        show-word-limit
                        resize="none"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="地址" prop="longitude">
                      <el-input
                        clearable
                        @keyup.enter.native="changeAddress()"
                        @change="changeAddress"
                        v-model="addressQuery.address"
                        placeholder="请输入地址"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>

              <div class="map-group">
                <baidu-map
                  :center="center"
                  :zoom="zoom"
                  @ready="handler"
                  id="allmap"
                  :scroll-wheel-zoom="true"
                ></baidu-map>
                <div class="address-list" v-if="addressList.length">
                  <div class="select-tip">
                    请选择地址<span class="rule-tip">*</span>
                  </div>
                  <div
                    class="item"
                    v-for="(item, index) in addressList"
                    :key="index"
                  >
                    <div
                      class="marker"
                      :style="
                        'background-position: -23px -' + 25 * index + 'px;'
                      "
                    ></div>
                    <div class="info" @click="chooseAddress(item)">
                      <div>
                        <a :href="item.url" target="_blank">{{ item.title }}</a>
                      </div>
                      <div>地址：{{ item.address }}</div>
                      <!-- <div>坐标：{{ item.point.lng }},{{ item.point.lat }}</div> -->
                    </div>
                  </div>
                </div>
                <div class="none-list" v-else>暂无相关地点，请重新输入地址</div>
              </div>
              <div class="group-btn">
                <el-button type="primary" @click="saveInfo">保存</el-button>
                <el-button @click="cancel">取消</el-button>
              </div>
            </div>
          </el-form>
          <el-form
            v-else-if="area.name"
            label-position="left"
            label-width="4rem"
          >
            <div class="info-view">
              <div class="view-title">
                {{ area.name }}
                <div class="edit-btn" @click="editPost">管理</div>
              </div>
              <div class="view-box">
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="名称">
                      {{ area.name | nullValue }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="是否启用">
                      <div class="status">
                        <!-- <svg-icon
                          class="svg"
                          v-if="!area.status"
                          icon-class="status-close"
                        />
                        <svg-icon class="svg" v-else icon-class="success" /> -->
                        {{ area.status ? "是" : "否" | nullValue }}
                      </div>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="8">
                    <el-form-item label="邮编">
                      {{ area.postcode | nullValue }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="别名">
                      {{ area.alias | nullValue }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="类型">
                      {{ area.type | nullValue }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="备注" class="auto-height">
                      {{ area.more | nullValue }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item label="地址">
                      {{ addressQuery.address | nullValue }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <!-- <div class="city-area">
                <baidu-map
                  :center="center"
                  :zoom="zoom"
                  @ready="handler"
                  id="allmap"
                  :scroll-wheel-zoom="true"
                ></baidu-map>
              </div>
              <div class="no-area" v-show="!area.longitude && !area.latitude">
                暂未选择地址，请选择地址
              </div> -->
            </div>
          </el-form>
        </div>
        <div class="main-right-none" v-if="areaNone && operation != 'create'">
          <img src="@/assets/image/none-img.png" alt="" />
          <div class="none-tips">
            当前暂无地区，单击下面“立即添加”按钮添加新地区。
          </div>
          <el-button type="primary" @click="addArea">立即添加</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { deepCopy } from "@/utils/deepCopy";
import headerTop from "@/components/HeaderTop";
import {
  getAreaTree,
  getAreaInfo,
  deleteAreas,
  createAreas,
  updateArea,
} from "@/http/api/area";
import { getAreaSettings } from "@/http/api/system";
import { debounce } from "@/utils/debounce";

export default {
  components: {
    headerTop,
  },
  data() {
    return {
      areaSearch: "",
      operation: "",
      selectedId: "",
      isLoading: true,
      isEdit: false,
      areaNone: false,
      search: "",
      operation: "",
      showTips: true,
      areaForm: {
        parentId: "",
        name: "",
        alias: "",
        postcode: "",
        longitude: "",
        latitude: "",
        address: "",
        more: "",
        type: "",
        sort: 0,
        expanded: true,
        status: true,
      },
      areaRules: {
        name: [{ required: true, message: "请输入地区名称", trigger: "blur" }],
      },
      filter: {
        filter: "",
        condition: "",
        skipCount: 0,
        maxResultCount: 1000,
        startTime: null,
        endTime: null,
        expend: false,
        loadMode: "Async",
      },
      addressQuery: {
        address: "",
        latitude: "",
        longitude: "",
      },
      areas: [],
      areaAll: [],
      area: {},
      areaType: [],
      addressList: [],
      permissions: this.$store.getters.permissions,
      isEnterAddress: false,
      zoom: 12,
      center: {
        lng: "",
        lat: "",
      },
    };
  },
  mounted() {
    this.searchAreas();
    this.getAreaSettings();
    this.$watch(
      "areaSearch",
      debounce((val) => {
        this.searchAreas();
      }, 200)
    );
  },
  computed: {},
  methods: {
    getAreaSettings() {
      getAreaSettings().then((res) => {
        res.result.map((item) => {
          if (
            (item.displayName = "DisplayName:Deer.Area.Collection.AreaType")
          ) {
            this.areaType = item.value;
          }
        });
      });
    },
    showTip() {
      this.showTips = !this.showTips;
    },
    chooseAddress(res) {
      //console.log(res, 9999);
      this.addressQuery.address = res.address;
      this.addressQuery.latitude = res.point.lat;
      this.addressQuery.longitude = res.point.lng;
      this.areaForm.address = res.address;
      this.areaForm.latitude = res.point.lat;
      this.areaForm.longitude = res.point.lng;
    },
    loadTreeNodes(val, resolve) {
      var node = val.data.data;
      if (node) {
        let query = {
          parentId: node.id,
          loadMode: "async",
          maxResultCount: 1000,
        };
        getAreaTree(query).then((res) => {
          resolve(res.result.items);
        });
      }
    },
    // 输入地址
    changeAddress() {
      this.addressList = [];
      this.isEnterAddress = true;
      this.handler();
    },
    handler() {
      var map = new BMap.Map("allmap"); // 创建Map实例
      //console.log(this.zoom, "地图缩放");
      if (this.addressQuery.address) {
        map.centerAndZoom(this.addressQuery.address, 12);
      } else {
        map.centerAndZoom("郑州", 12);
      }
      map.enableScrollWheelZoom(true); //开启鼠标滚轮缩放
      var myGeo = new BMap.Geocoder();
      // 将地址解析结果显示在地图上,并调整地图视野
      var that = this;

      if (that.addressQuery.address) {
        var local = new BMap.LocalSearch(map, {
          renderOptions: { map: map },
        });
        local.search(this.addressQuery.address);
        //地址搜索后的回调
        local.setSearchCompleteCallback((results) => {
          if (local.getStatus() == BMAP_STATUS_SUCCESS) {
            // 判断状态是否正确
            var s = [];
            for (var i = 0; i < results.getCurrentNumPois(); i++) {
              s.push(results.getPoi(i));
            }
            this.addressList = s;
          }
        });
      }
    },
    // 搜索地区
    searchAreas() {
      if (this.areaSearch) {
        getAreaTree(this.filter).then((res) => {
          this.areas = res.result.items;
          if (this.areas.length) {
            this.getAreaInfo(this.areas[0].data.id);
            this.selectedId = this.areas[0].data.id;
          }
        });
      } else {
        getAreaTree(this.filter).then((res) => {
          //console.log(res, "获取deres");
          this.areaAll = res.result.items;
          this.areas = this.areaAll;
          if (this.areas.length) {
            this.getAreaInfo(this.areas[0].data.id);
            this.selectedId = this.areas[0].data.id;
            this.areaNone = false;
          } else {
            this.areaNone = true;
          }
          this.isLoading = false;
        });
      }
    },
    // 获取地区详情
    getAreaInfo(id) {
      getAreaInfo(id).then((res) => {
        this.addressList = [];
        this.area = res.result;

        this.addressQuery.address = res.result.address;
        this.addressQuery.longitude = res.result.longitude;
        this.addressQuery.latitude = res.result.latitude;
        if (res.result.level == 1) {
          this.zoom = 12;
        } else if (res.result.level == 2) {
          this.zoom = 13;
        } else if (res.result.level == 3) {
          this.zoom = 14;
        } else if (res.result.level == 4) {
          this.zoom = 14;
        }
        // //console.log(this.zoom, this.center,11111);
        // if(this.center.lng&&this.center.lat){
        // this.changeAddress();
        // }
      });
    },
    // 删除节点
    delPost() {
      if (this.permissions["Area.Delete"]) {
      if (this.operation == "checked") {
        let text = this.area.parentId ? "地区" : "地区";
        this.$confirm(`此操作将永久删除该${text}, 是否继续?`, "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        })
          .then(() => {
            deleteAreas(this.selectedId).then((res) => {
              if (res) {
                this.$message.success({
                  message: "删除成功",
                  showClose: true,
                });
              }
              this.searchAreas();
              this.operation = "";
            });
          })
          .catch(() => {
            //console.log("已取消");
          });
      }
      } else {
        this.$message.warning({
          message: `您暂无删除地区权限`,
          showClose: true,
        });
      }
    },
    // 添加地区
    addArea(data) {
      this.addressQuery.address = "";
      this.addressQuery.latitude = "";
      this.addressQuery.longitude = "";
      this.areaForm.address = "";
      this.areaForm.latitude = "";
      this.areaForm.longitude = "";
      this.addressList = [];
      if (this.permissions["Area.Create"]) {
      this.areaForm = {
        parentId: "",
        name: "",
        alias: "",
        postcode: "",
        longitude: "",
        latitude: "",
        more: "",
        type: "",
        sort: 0,
        expanded: true,
        status: true,
      };
      let parentId = this.area.parentId;
      if (data.data) {
        // 地区添加下级
        this.selectedId = data.data.id;
        this.areaForm.sort = 1;
      } else if (parentId) {
        // 地区添加同级
        this.selectedId = parentId;
        this.areaForm.sort = 1;
      } else {
        // 添加地区
        this.selectedId = "";
        this.areaForm.sort = 0;
      }
      this.operation = "create";
      this.isEdit = true;
      } else {
        this.$message.warning({
          message: `您暂无添加地区权限`,
          showClose: true,
        });
      }
    },
    // 点击节点
    nodeClick(node, data) {
      this.operation = "checked";
      this.isEdit = false;
      this.selectedId = node.data.id;
      this.getAreaInfo(this.selectedId);
    },
    editPost() {
      if (this.permissions["Area.Update"]) {
      this.isEdit = true;
      this.operation = "edit";
      // this.areaForm = deepCopy(this.area);
      this.areaForm.parentId = this.area.parentId;
      this.areaForm.address = this.area.address;
      this.areaForm.name = this.area.name;
      this.areaForm.alias = this.area.alias;
      this.areaForm.postcode = this.area.postcode;
      this.areaForm.longitude = this.area.longitude;
      this.areaForm.latitude = this.area.latitude;
      this.areaForm.more = this.area.more;
      this.areaForm.type = this.area.type;
      this.areaForm.sort = this.area.sort;
      this.areaForm.expanded = this.area.expanded;
      this.areaForm.status = this.area.status;

      this.addressQuery.address = this.area.address;
      this.addressQuery.latitude = this.area.latitude;
      this.addressQuery.longitude = this.area.longitude;
      } else {
        this.$message.warning({
          message: `您暂无管理地区权限`,
          showClose: true,
        });
      }
    },
    saveInfo() {
      this.$refs.areaForm.validate((valid) => {
        if (valid) {
          if (this.operation == "create") {
            if (this.selectedId) {
              this.areaForm.parentId = this.selectedId;
            }
            createAreas(this.areaForm).then((res) => {
              if (res) {
                this.$message.success({
                  message: "添加成功",
                  showClose: true,
                });
              }
              this.area = res.result;
              this.searchAreas();
            });
          } else if (this.operation == "edit") {
            updateArea(this.selectedId, this.areaForm).then((res) => {
              if (res) {
                this.$message.success({
                  message: "修改成功",
                  showClose: true,
                });
              }            
              this.searchAreas();
            });
          }
          this.isEdit = false;
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    cancel() {
      this.operation = "";
      this.isEdit = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/mixin.scss";
.hr-area {
  text-align: left;
  .title {
    color: #000000;
    font-size: 16px;
    font-weight: bold;
    padding: 17px 20px 17px;
    background: rgba(255, 255, 255, 1);
  }

  .svg-icon {
    cursor: pointer;
  }

  .area-container {
    padding: 20px 180px;

    .container-tip {
      @include flex(row, flex-start);
      margin-bottom: 20px;
      padding: 20px;
      font-size: 12px;
      font-weight: 500;
      background: #fff;
      .icon-tips {
        color: $--color-primary;
        padding: 10px 0;
      }
      ul {
        margin: 0;
        position: relative;
        padding-left: 10px;
        width: 100%;
        .icon-tips-bg {
          position: absolute;
          right: 0px;
          bottom: -94px;
          font-size: 250px;
        }
        li {
          @include flex(row, center);
          margin-bottom: 10px;
          width: 100%;
          span {
            display: inline-block;
            margin-right: 5px;
            border-radius: 50%;
            padding: 2px;
            background: #111;
          }
        }
        .tips-tit {
          justify-content: space-between;
          .tips-btn {
            position: relative;
            z-index: 99;
            padding: 10px;
            cursor: pointer;
          }
        }
        li:last-child {
          margin-bottom: 0px;
        }
      }
    }

    .container-main {
      display: flex;

      .main-left {
        border-radius: $--border-radius-base;
        padding: 20px;
        width: 315px;
        background: #fff;
        .left-operation {
          display: flex;
          align-items: center;
          justify-content: space-between;

          .operation-btn {
            display: flex;
            align-items: center;
            justify-content: space-between;

            width: 50px;

            .el-tooltip {
              height: 16px;
              &:first-child {
                height: 10px;
              }
            }

            .btn-add {
              width: 10px;
              height: 10px;
              vertical-align: baseline;
            }

            .btn-del {
              width: 16px;
              height: 16px;
              color: #888;
            }
          }

          .area-search {
            width: 220px;
            height: 30px;
          }
        }

        .area-items {
          margin-top: 20px;

          // .custom-tree {
          //   ::v-deep .el-tree-node__children {
          //     .el-tooltip {
          //       display: none;
          //     }
          //   }
          // }
        }
      }

      .main-right {
        border-radius: $--border-radius-base;
        margin-left: 20px;
        padding: 20px;
        width: 315px;
        background: #fff;
        overflow: hidden;
        width: calc(100% - 354px);
        // min-height: calc(100vh - 268px);

        .view-title {
          display: flex;
          justify-content: space-between;
          margin-bottom: 25px;

          font-size: 14px;
          font-weight: bold;
          color: #000;

          .edit-btn {
            position: relative;
            z-index: 500;
            font-size: 14px;
            font-weight: 400;
            color: $--color-primary;
            cursor: pointer;
          }
        }

        .info-view,
        .edit-view {
          .view-box {
            .el-select{
              width: 100%;
            }
            .status {
              @include flex(row, center);
              .svg {
                margin-right: 5px;
              }
              .success {
                color: #0abf5b;
              }
              .close {
                color: #f44242;
              }
            }
            .city-area {
              width: 100%;
              height: 296px;
              margin-top: 20px;

              box-sizing: border-box;
              @include flex(row, center);

              #allmap {
                width: 800px;
                height: 100%;
              }
            }
            .no-area {
              margin-top: 20px;
              width: 800px;
              text-align: center;
              font-size: 20px;
              font-weight: 500;
              color: #999;
            }
          }
        }

        .edit-view {
          .view-box {
            margin-bottom: 20px;
            ul {
              li {
                @include flex(row, center);
                padding: 15px 10px;
                width: 379px;
                .el-select {
                  width: 100%;
                }
              }
              .view-detail-status {
                padding: 5px 10px;
                width: 100%;
              }
            }
          }
          .select-tip {
            padding-left: 10px;

            .rule-tip {
              display: inline-block;
              margin-left: 4px;
              color: #f56c6c;
            }
          }
          .map-group {
            width: 800px;
            height: 296px;
            margin-top: 10px;
            border: 1px solid #ddd;
            box-sizing: border-box;
            @include flex(row, center);

            #allmap {
              width: 100%;
              height: 100%;
            }

            .address-list {
              width: 262px;
              height: 100%;
              overflow-y: auto;

              .select-tip {
                padding-left: 10px;

                .rule-tip {
                  display: inline-block;
                  margin-left: 4px;
                  color: #f56c6c;
                }
              }

              .no-data {
                @include flex(row, center);
                color: #888;
                text-align: center;
              }

              .item {
                padding: 10px 7px 0;
                @include flex(row, flex-start);
                line-height: normal;

                .marker {
                  width: 25px;
                  height: 25px;
                  margin-top: 2px;
                  background: url(~@/assets/image/map-markers.png) no-repeat 0 0;
                }

                .info {
                  width: 200px;
                  margin-left: 4px;
                  padding-top: 3px;
                  padding-left: 2px;
                  cursor: pointer;

                  div {
                    padding-bottom: 8px;
                  }

                  &:hover {
                    background-color: #f0f0f0;
                  }
                }
              }
            }
            .none-list {
              width: 262px;
              height: 296px;
              line-height: 296px;
              text-align: center;
              color: #999;
            }
          }
          .group-btn {
            margin: 12px 0 10px;
          }
        }

        .permission-item {
          margin-right: 10px;

          &:last-child {
            margin-right: 0;
          }
        }

        .edit-btn {
          color: $--color-primary;
          cursor: pointer;
        }
      }
      .main-right-none {
        @include flex(column, center);
        justify-content: center;
        margin-left: 20px;
        padding: 20px;
        width: calc(100% - 354px);
        background: #fff;
        img {
          margin-bottom: 10px;
          width: 40%;
          height: auto;
        }
        .none-tips {
          margin-bottom: 10px;
          color: #888888;
        }
      }
    }
  }

  .area-container {
    padding: 20px;
  }
}
</style>